import { CalendarMode, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import React, { JSX } from "react";

import { AuditRoleStatus } from "../../../../audit_planner/parts/audit_role_status/audit_role_status";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "../side_panel_rows.module.scss";

type RowBadgeProps = {
  row: Row;
};

export const RowBadge = ({ row }: RowBadgeProps): JSX.Element | null => {
  const { calendarMode } = useBookingsOverviewContext();
  const { type, original } = row;

  const isRole = type === RowType.Role;
  const isEngagement = type === RowType.Engagement;

  if (calendarMode !== CalendarMode.Projects || !(isRole || isEngagement)) {
    return null;
  }

  const isDraftOrComplete =
    (original as ProjectItem).activity.state === "draft" ||
    (original as ProjectItem).activity.state === "complete";

  return (
    <AuditRoleStatus
      role={(original as ProjectItem).activity}
      withStateBadge={isRole || (isEngagement && isDraftOrComplete)}
      withWorkflowStateBadge={isRole}
      classes={{
        root: css.statusBadgeRoot,
        workflowStateBadge: css.workflowStateBadge
      }}
      activityStatusBadgeClasses={{
        root: css.activityStatusBadgeRoot
      }}
    />
  );
};
